import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSession } from "../../session/Context";
import { toast } from "react-toastify";
import React from "react";
import API from "../../Api";
import ApiKeyCard from "../ApiKeyCard";

export default function ApiKey() {
  const navigate = useNavigate();
  const { brand } = useSession();
  const [keys, setKeys] = useState<any>({});
  const [showFormKeys, setShowFormKeys] = useState(false);
  const [keyData, setKeyData] = useState({
    name: "",
  });

  useEffect(() => {
    // Get current api keys
    let url = "/api/v1";
    if (brand !== "") {
      url += "/brand/" + brand + "/access-token";
    } else {
      url += "/brand/root/access-token";
    }

    API(url, {
      method: "GET",
    })
      .then((resp) => {
        setKeys(resp);
      })
      .catch((e) => {
        toast.error("Error " + e, { theme: "colored" });
        console.error(e);
      });
  }, []);

  const changeKeyData = (e: any) => {
    const { name, value } = e.target;

    //Desctructing to get values
    setKeyData({
      ...keyData,
      [name]: value,
    });
  };

  const onSubmit = (event: React.FormEvent<HTMLFormElement>): void => {
    event.preventDefault();
    let url = "/api/v1";
    if (brand !== "") {
      url += "/brand/" + brand + "/access-token";
    } else {
      url += "/brand/root/access-token";
    }

    API(url, {
      method: "POST",
      body: JSON.stringify({
        type: "new",
        name: keyData.name,
      }),
    })
      .then((resp) => {
        toast.success("Successfully added new API key " + keyData.name, {
          theme: "colored",
        });

        setShowFormKeys(false);
        setKeyData({ name: "" });
        let temp = resp.access_token;
        setKeys({ ...keys, [temp]: resp });
      })
      .catch((e) => {
        toast.error("Error " + e, { theme: "colored" });
        console.error(e);
        setShowFormKeys(false);
        setKeyData({ name: "" });
      });
  };

  return (
    <div className="settings-section">
      <div className="messages">
        <h3>API keys</h3>
      </div>

      {showFormKeys ? (
        <>
          <form onSubmit={onSubmit} className="form">
            <div>
              <label>Name </label>
              <input
                required
                type="text"
                style={{ width: "300px" }}
                name="name"
                maxLength={240}
                value={keyData.name}
                onChange={changeKeyData}
              ></input>
            </div>

            <button
              className="btn btn-primary issuer-form"
              type="submit"
              value="Add"
            >
              Add API key
            </button>
          </form>

          <button
            className="btn btn-secondary issuer-form"
            type="submit"
            value="Back"
            onClick={() => {
              setShowFormKeys(false);
              setKeyData({ name: "" });
            }}
          >
            Back
          </button>
        </>
      ) : (
        <>
          <button
            className="btn btn-primary"
            type="submit"
            value="Add"
            onClick={() => {
              setShowFormKeys(true);
            }}
          >
            Add API key
          </button>

          <div className="apikey_section">
            {Object.keys(keys).length === 0 ? (
              <>{/* No API keys yet. */}</>
            ) : (
              <>
                {Object.values(keys).map((key: any) => {
                  return (
                    <ApiKeyCard
                      key={key.access_token}
                      data={key}
                      updateData={(newData) => {
                        const newKeys = { ...keys };
                        newKeys[key.access_token] = newData;
                        setKeys(newKeys);
                      }}
                      deleteData={() => {
                        const newKeys = { ...keys };
                        delete newKeys[key.access_token];
                        setKeys(newKeys);
                      }}
                    />
                  );
                })}
              </>
            )}
          </div>
        </>
      )}
    </div>
  );
}
